export const template = {
	type: 'doc',
	content: [
		{
			type: 'table',
			attrs: { layout: 'default' },
			content: [
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [179.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Driver', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [581.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ type: 'placeholder', attrs: { text: '@ mention the driver' } }],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [179.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Approver', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [581.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ type: 'placeholder', attrs: { text: '@ approver' } }],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [179.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Contributors', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [581.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ type: 'placeholder', attrs: { text: '@ contributors' } }],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [179.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Informed', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [581.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ type: 'placeholder', attrs: { text: '@ stakeholders' } }],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [179.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Objective', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [581.0] },
							content: [
								{
									type: 'paragraph',
									content: [
										{
											type: 'placeholder',
											attrs: { text: 'Summarize the objective in 1-2 sentences' },
										},
									],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [179.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Due date', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [581.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ type: 'placeholder', attrs: { text: 'Type // to add a date' } }],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [179.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Key outcomes', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [581.0] },
							content: [
								{
									type: 'paragraph',
									content: [
										{
											type: 'placeholder',
											attrs: { text: 'List expected outcomes and success metrics' },
										},
									],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [179.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Status', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [581.0] },
							content: [
								{
									type: 'paragraph',
									content: [
										{
											type: 'status',
											attrs: { color: 'neutral', style: 'bold', text: 'not started' },
										},
										{ text: ' / ', type: 'text' },
										{
											type: 'status',
											attrs: { color: 'yellow', style: 'bold', text: 'in progress' },
										},
										{ text: ' / ', type: 'text' },
										{ type: 'status', attrs: { color: 'green', style: 'bold', text: 'complete' } },
									],
								},
							],
						},
					],
				},
			],
		},
		{ type: 'paragraph' },
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{ type: 'emoji', attrs: { id: '1f914', text: '\\uD83E\\uDD14', shortName: ':thinking:' } },
				{ text: ' Problem Statement', type: 'text' },
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'placeholder',
					attrs: {
						text: "Describe the problem and its impact. Include the hypothesis that's driving your work (\"We think X will do Y, and we'll know we've succeeded if Z\").",
					},
				},
			],
		},
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{ type: 'emoji', attrs: { id: '1f3af', text: '🎯', shortName: ':dart:' } },
				{ text: ' Scope', type: 'text' },
			],
		},
		{
			type: 'table',
			attrs: { layout: 'default' },
			content: [
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableHeader',
							attrs: { colspan: 1, background: '#e3fcef', rowspan: 1, colwidth: [187.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Must have:', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableHeader',
							attrs: { colspan: 1, background: '#ffffff', rowspan: 1, colwidth: [571.0] },
							content: [
								{
									type: 'bulletList',
									content: [
										{
											type: 'listItem',
											content: [
												{
													type: 'paragraph',
													content: [
														{
															type: 'placeholder',
															attrs: { text: "Add your project's core requirements" },
														},
													],
												},
											],
										},
										{ type: 'listItem', content: [{ type: 'paragraph' }] },
									],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, background: '#fffae6', rowspan: 1, colwidth: [187.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Nice to have:', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [571.0] },
							content: [
								{
									type: 'bulletList',
									content: [
										{
											type: 'listItem',
											content: [
												{
													type: 'paragraph',
													content: [
														{
															type: 'placeholder',
															attrs: { text: "Add anything you want but don't strictly need" },
														},
													],
												},
											],
										},
										{ type: 'listItem', content: [{ type: 'paragraph' }] },
									],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, background: '#ffebe6', rowspan: 1, colwidth: [187.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Not in scope:', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [571.0] },
							content: [
								{
									type: 'bulletList',
									content: [
										{
											type: 'listItem',
											content: [
												{
													type: 'paragraph',
													content: [
														{
															type: 'placeholder',
															attrs: { text: "Add anything you don't want to include" },
														},
													],
												},
											],
										},
										{ type: 'listItem', content: [{ type: 'paragraph' }] },
									],
								},
							],
						},
					],
				},
			],
		},
		{ type: 'paragraph' },
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{
					type: 'emoji',
					attrs: { id: '1f5d3', text: '\\uD83D\\uDDD3', shortName: ':calendar_spiral:' },
				},
				{ text: ' Timeline', type: 'text' },
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'placeholder',
					attrs: {
						text: 'Type /planner to create a visual roadmap and help your team stay on track. To edit workstreams or dates, select the placeholder below and tap the pencil icon.',
					},
				},
			],
		},
		{
			type: 'extension',
			attrs: {
				layout: 'default',
				extensionType: 'com.atlassian.confluence.macro.core',
				extensionKey: 'roadmap',
				parameters: {
					macroParams: {
						maplinks: { value: '' },
						timeline: { value: 'true' },
						source: {
							value:
								'%7B%22title%22%3A%22Roadmap%20Planner%22%2C%22timeline%22%3A%7B%22startDate%22%3A%222021-10-15%2000%3A00%3A00%22%2C%22endDate%22%3A%222022-06-15%2000%3A00%3A00%22%2C%22displayOption%22%3A%22MONTH%22%7D%2C%22lanes%22%3A%5B%7B%22title%22%3A%22Lane%201%22%2C%22color%22%3A%7B%22lane%22%3A%22%23d04437%22%2C%22bar%22%3A%22%23dc7369%22%2C%22text%22%3A%22%23ffffff%22%2C%22count%22%3A1%7D%2C%22bars%22%3A%5B%7B%22title%22%3A%22Feature%201%22%2C%22description%22%3A%22This%20is%20the%20first%20bar.%22%2C%22startDate%22%3A%222021-10-23%2017%3A06%3A32%22%2C%22duration%22%3A2%2C%22rowIndex%22%3A1%2C%22id%22%3A%2299880195-7faf-4b2f-ac44-a38516c4cad5%22%2C%22pageLink%22%3A%7B%7D%7D%2C%7B%22title%22%3A%22Feature%202%22%2C%22description%22%3A%22This%20is%20the%20second%20bar.%22%2C%22startDate%22%3A%222022-01-01%2014%3A43%3A57%22%2C%22duration%22%3A1.4356435643564356%2C%22rowIndex%22%3A2%2C%22id%22%3A%22604cae13-314a-4848-b142-95d3570aa3db%22%2C%22pageLink%22%3A%7B%7D%7D%2C%7B%22rowIndex%22%3A0%2C%22startDate%22%3A%222022-03-08%2001%3A25%3A32%22%2C%22id%22%3A%22739eee1a-3ad0-4154-a8a7-d630942c1b71%22%2C%22title%22%3A%22Feature%203%22%2C%22description%22%3A%22%22%2C%22duration%22%3A1.4356435643564356%2C%22pageLink%22%3A%7B%7D%7D%2C%7B%22rowIndex%22%3A3%2C%22startDate%22%3A%222022-04-30%2002%3A36%3A49%22%2C%22id%22%3A%22d2721513-87bf-4ea5-9981-d3971248c8f5%22%2C%22title%22%3A%22Feature%204%22%2C%22description%22%3A%22%22%2C%22duration%22%3A1.6633663366336633%2C%22pageLink%22%3A%7B%7D%7D%5D%7D%2C%7B%22title%22%3A%22Lane%202%22%2C%22color%22%3A%7B%22lane%22%3A%22%233b7fc4%22%2C%22bar%22%3A%22%236c9fd3%22%2C%22text%22%3A%22%23ffffff%22%2C%22count%22%3A1%7D%2C%22bars%22%3A%5B%7B%22title%22%3A%22iOS%20app%22%2C%22description%22%3A%22This%20is%20the%20third%20bar.%22%2C%22startDate%22%3A%222021-10-13%2021%3A23%3A10%22%2C%22duration%22%3A2.5%2C%22rowIndex%22%3A0%2C%22id%22%3A%22b10f9e72-539a-4a31-88bd-746bd09d7f1e%22%2C%22pageLink%22%3A%7B%7D%7D%2C%7B%22rowIndex%22%3A1%2C%22startDate%22%3A%222022-03-27%2003%3A08%3A19%22%2C%22id%22%3A%22e329a842-d49c-4f39-83ee-4d7af06dece7%22%2C%22title%22%3A%22Android%20app%22%2C%22description%22%3A%22%22%2C%22duration%22%3A1.683168316831683%2C%22pageLink%22%3A%7B%7D%7D%5D%7D%5D%2C%22markers%22%3A%5B%7B%22title%22%3A%22Marker%201%22%2C%22markerDate%22%3A%222018-10-05%2007%3A07%3A43%22%7D%2C%7B%22markerDate%22%3A%222019-03-15%2000%3A00%3A00%22%2C%22title%22%3A%22Marker%22%7D%5D%7D',
						},
						pagelinks: { value: '' },
						title: { value: 'Roadmap%20Planner' },
						hash: { value: 'bf72b0d2e5ea24888f6179cf74c6606f' },
					},
					macroMetadata: {
						macroId: { value: '1526b447-0de1-4153-9546-c785e201427a' },
						schemaVersion: { value: '1' },
						placeholder: [
							{
								type: 'image',
								data: {
									url: 'https://test-template.atlassian.net/wiki/plugins/servlet/roadmap/image/placeholder?hash=bf72b0d2e5ea24888f6179cf74c6606f&width=1000&height=300&timeline=true',
								},
							},
						],
						title: 'Roadmap Planner',
					},
				},
				localId: '233a37cb-e6a7-444b-81d8-1620bbbebb52',
			},
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'placeholder',
					attrs: {
						text: 'Type /trello to add a card or board to this page or /jira to include a Jira issue, chart, or project.',
					},
				},
			],
		},
		{ type: 'paragraph' },
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{
					type: 'emoji',
					attrs: { id: '1f6a9', text: '\\uD83D\\uDEA9', shortName: ':triangular_flag_on_post:' },
				},
				{ text: ' Milestones and deadlines', type: 'text' },
			],
		},
		{
			type: 'table',
			attrs: { layout: 'default' },
			content: [
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableHeader',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [348.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Milestone', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableHeader',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [142.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Owner', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableHeader',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [131.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Deadline', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableHeader',
							attrs: { colspan: 1, background: '#f4f5f7', rowspan: 1, colwidth: [139.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Status', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [348.0] },
							content: [
								{
									type: 'paragraph',
									content: [
										{ type: 'placeholder', attrs: { text: 'e.g., Finalize designs for v1' } },
									],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [142.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ type: 'placeholder', attrs: { text: '@ owner' } }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [131.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ type: 'placeholder', attrs: { text: 'Type // to add a date' } }],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [139.0] },
							content: [{ type: 'paragraph' }],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [348.0] },
							content: [{ type: 'paragraph' }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [142.0] },
							content: [{ type: 'paragraph' }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [131.0] },
							content: [{ type: 'paragraph' }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [139.0] },
							content: [{ type: 'paragraph' }],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [348.0] },
							content: [{ type: 'paragraph' }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [142.0] },
							content: [{ type: 'paragraph' }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [131.0] },
							content: [{ type: 'paragraph' }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [139.0] },
							content: [{ type: 'paragraph' }],
						},
					],
				},
			],
		},
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{ type: 'emoji', attrs: { id: '1f517', text: '\\uD83D\\uDD17', shortName: ':link:' } },
				{ text: ' Reference materials', type: 'text' },
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'placeholder',
					attrs: { text: 'Add links to relevant research and any other key documents' },
				},
			],
		},
		{ type: 'paragraph', content: [{ type: 'hardBreak' }] },
	],
	version: 1,
};
